var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BrandBookSectionHeroImage',{staticClass:"brand-book-about-hero",attrs:{"src":"PREÂMBULO.png"}})
}
var staticRenderFns = []

export { render, staticRenderFns }